function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React, { Component } from 'react';
import objectAssign from 'object-assign';
import LensPropTypes from '../../prop-types/Lens';
import clamp from 'clamp';
import dataUri from './assets/textured-lens-data-uri';
var PositiveSpaceLens = /*#__PURE__*/function (_Component) {
  _inherits(PositiveSpaceLens, _Component);
  var _super = _createSuper(PositiveSpaceLens);
  function PositiveSpaceLens() {
    _classCallCheck(this, PositiveSpaceLens);
    return _super.apply(this, arguments);
  }
  _createClass(PositiveSpaceLens, [{
    key: "dimensions",
    get: function get() {
      var _this$props$cursorOff = this.props.cursorOffset,
        cursorOffsetX = _this$props$cursorOff.x,
        cursorOffsetY = _this$props$cursorOff.y;
      return {
        width: cursorOffsetX * 2,
        height: cursorOffsetY * 2
      };
    }
  }, {
    key: "positionOffset",
    get: function get() {
      var _this$props = this.props,
        _this$props$cursorOff2 = _this$props.cursorOffset,
        cursorOffsetX = _this$props$cursorOff2.x,
        cursorOffsetY = _this$props$cursorOff2.y,
        _this$props$position = _this$props.position,
        positionX = _this$props$position.x,
        positionY = _this$props$position.y,
        _this$props$smallImag = _this$props.smallImage,
        imageHeight = _this$props$smallImag.height,
        imageWidth = _this$props$smallImag.width;
      var _this$dimensions = this.dimensions,
        width = _this$dimensions.width,
        height = _this$dimensions.height;
      var top = positionY - cursorOffsetY;
      var left = positionX - cursorOffsetX;
      var maxTop = imageHeight - height;
      var maxLeft = imageWidth - width;
      var minOffset = 0;
      return {
        top: clamp(top, minOffset, maxTop),
        left: clamp(left, minOffset, maxLeft)
      };
    }
  }, {
    key: "defaultStyle",
    get: function get() {
      var fadeDurationInMs = this.props.fadeDurationInMs;
      return {
        transition: "opacity ".concat(fadeDurationInMs, "ms ease-in"),
        backgroundImage: "url(".concat(dataUri, ")")
      };
    }
  }, {
    key: "userSpecifiedStyle",
    get: function get() {
      var style = this.props.style;
      return style;
    }
  }, {
    key: "isVisible",
    get: function get() {
      var _this$props2 = this.props,
        isActive = _this$props2.isActive,
        isPositionOutside = _this$props2.isPositionOutside;
      return isActive && !isPositionOutside;
    }
  }, {
    key: "priorityStyle",
    get: function get() {
      var _this$dimensions2 = this.dimensions,
        width = _this$dimensions2.width,
        height = _this$dimensions2.height;
      var _this$positionOffset = this.positionOffset,
        top = _this$positionOffset.top,
        left = _this$positionOffset.left;
      return {
        position: 'absolute',
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        opacity: this.isVisible ? 1 : 0
      };
    }
  }, {
    key: "compositStyle",
    get: function get() {
      return objectAssign(this.defaultStyle, this.userSpecifiedStyle, this.priorityStyle);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: this.compositStyle
      });
    }
  }]);
  return PositiveSpaceLens;
}(Component);
PositiveSpaceLens.propTypes = LensPropTypes;
PositiveSpaceLens.defaultProps = {
  style: {}
};
export { PositiveSpaceLens as default };